// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["pixi","patchnotes","discord-sdk","ui-game","shared","static-vendors","shared-web","vendors"], () => (__webpack_require__("./code/client/shared/scripts/WebpackEntry.ts")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["pixi","patchnotes","discord-sdk","ui-game","shared","static-vendors","shared-web","vendors"], () => (__webpack_require__("./code/client/web/scripts/EntryWeb.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
